import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'

import { useWindowSize } from '../../hooks/useWindowSize';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { GroupsFechtAPI } from '../../api/Groups'
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import img_1 from '../../assets/img/vending/products/Coke.png'
import { Container, Row, Col } from 'react-bootstrap';
import { GiDivingDagger } from 'react-icons/gi';
import { FaInfoCircle } from 'react-icons/fa';
import { PublicityFechtAPI } from '../../api/Publicity';
import { VendingAndroidFetchAPI } from '../../api/LocalRequest/VendingAndroid';

import VendingModalCategories from './VendingModalCategories';
import VendingModalCart from './VendingModalCart';
import VendingModalProduct from './VendingModalProduct';
import VendingStock from './VendingStock';
import VendingIdel from './VendingIdel';
import ModalLocker from './ModalLocker';
import { BusinessFetchAPI } from '../../api/Business';
import { MachinesFetchAPI } from '../../api/Machines';
import { StatusMenu } from '../../api/StatusMenu';
import AlertSmall from '../../components/Alerts/AlertSmall';
import VendingModalOperator from './VendingModalOperador';
import { VendingFetchAPI } from '../../api/LocalRequest/Vending';
import VendingModalSupport from './VendingModalSupport';
import TimerScreen from './TimerScreen';
import { RenderIf } from '../../components/utils/RenderIf';
import stand from '../../assets/img/vending/stand-2.png'
//import 'animate.css';
//Utils
import './vending.css'
import Empty from '../../utils/Empty';
import LoadingAlert from '../../components/Alerts/LoadingAlert';
import ErrorAlert from '../../components/Alerts/ErrorAlert';
import { OrderNumberFetchAPI } from '../../api/Paymentpost/OrderNumber';
import oledComunication from './OledComunication';
import { VendingSnakkyFetchAPI } from '../../api/LocalRequest/VendingSnakky';
import { Refresh } from 'react-flaticons';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import Menu from './Menu';
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';



// =========================================================================
// HOOK: grid config responsive según estilo y viewport
// =========================================================================
function useGridConfig(style = "glass") {
  const getConfig = () => {
    if (typeof window === "undefined") return { cols: 3, rows: 4, size: 12 };
    const w = window.innerWidth;
    const h = window.innerHeight;
    const isLandscape = w > h;

    let base;
    if (!isLandscape && h >= 1400 && w >= 900) base = { cols: 3, rows: 4 };
    else if (isLandscape && h < 600) base = { cols: 4, rows: 2 };
    else if (!isLandscape && w < 520) base = { cols: 2, rows: 3 };
    else if (!isLandscape && w < 900) base = { cols: 3, rows: 3 };
    else if (isLandscape && w < 1100) base = { cols: 4, rows: 2 };
    else if (isLandscape) base = { cols: 4, rows: 3 };
    else base = { cols: 3, rows: 4 };

    // Compact es horizontal: menos columnas, más filas
    if (style === "compact") {
      if (base.cols === 4) base = { cols: 2, rows: base.rows + 1 };
      else if (base.cols === 3) base = { cols: 2, rows: Math.max(base.rows, 4) };
      else if (base.cols === 2) base = { cols: 1, rows: Math.max(base.rows + 1, 4) };
    }
    return { cols: base.cols, rows: base.rows, size: base.cols * base.rows };
  };

  const [config, setConfig] = useState(getConfig);
  useEffect(() => { setConfig(getConfig()); }, [style]);
  useEffect(() => {
    let rafId = null;
    const onResize = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => setConfig(getConfig()));
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
  return config;
}

// =========================================================================
// COMPONENTE PRINCIPAL — toda la lógica original preservada
// =========================================================================
function VendingMenu({ setEventHandler, showModalKeyCode, setShowModalKeyCode }) {

  let token = localStorage.getItem("x-access-token");
  let business = JSON.parse(localStorage.getItem('business_vending'));
  let branchoffice = JSON.parse(localStorage.getItem('branchoffice_vending'));
  let machine = JSON.parse(localStorage.getItem('machine_vending'));

  const inputRefMenu = useRef(null);
  const [nameBusiness, setNameBusiness] = useState("Ordene aqui")
  const [statusTempTurnNow, setStatusTempTurnNow] = useState(true)
  const [logo, setLogo] = useState("")
  const [groups, setGroups] = useState([]);
  const [ipAndroid, setIpAndroid] = useState(() => {
    if (localStorage.getItem('machine_vending') !== undefined && localStorage.getItem('machine_vending') !== null && localStorage.getItem('machine_vending') !== "") {
      let machineLocal = JSON.parse(localStorage.getItem('machine_vending'))


      return machineLocal?.divices?.android_ip || 0
    } else {
      return 0
    }
  });
  const [selectGroup, setSelectGroup] = useState({ Group: "" })
  const [showModalSupport, setShowModalSupport] = useState(false)

  const [shoppingCart, setShoppingCart] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showModalProduct, setShowModalProduct] = useState(false)
  const [showModalShopingCart, setShowModalShopingCart] = useState(false);
  const [showModalIdel, setShowModalIdel] = useState(false);
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [contentSupport, setContentSupport] = useState({ title: "", body: [{ text: "" }, { text: "" }] })
  const [showModalStock, setShowModalStock] = useState(false)
  const [dataClient, setDataClient] = useState({ name: "Cliente", ruc: "0-000-00", dv: "00" });
  const [eventHandlerMenu, setEventHandlerMenu] = useState(0);
  const [eventHandlerTime, setEventHandlerTime] = useState(0);
  const [eventHandlerProduct, setEventHandlerProduct] = useState(0);
  const [temperature, setTemperature] = useState(0);
  const [humidity, setHumidity] = useState(0);
  const [statusComunicationVending, setStatusComunicationVending] = useState(false)
  const [showModalAuthOperator, setShowModalAuthOperator] = useState(false);
  const [statusScreen, setStatusScreen] = useState(false)
  const [time, setTime] = useState("")
  const [activityScreen, setActivityScreen] = useState(0)
  const [cantidadFilas, setCantidadFilas] = useState(0);
  const [count, setCount] = useState(0);
  const [publicity, setPublicity] = useState([]);
  const [video, setVideo] = useState("");
  const [amount, setAmount] = useState(1);
  const [showModaloutService, setShowModaloutService] = useState(false)
  const [orderNumber, setOrderNumber] = useState(0);
  const [handlerAutoAdd, setHandlerAutoAdd] = useState(false)
  const [payments, setPayments] = useState([]);
  const [activityTimer, setAtivityTimer] = useState(3);
  const [priority, setPriority] = useState(0);
  const [videoNow, setVideoNow] = useState('');
  const [menuFilteredByCategory, setMenuFilteredByCategory] = useState(false);
  let intervalTemp = 0;
  let activity = 0;
  let screenPause = 0;

  // ---------- NUEVO: state sólo para layout visual ----------
  const [cardStyle, setCardStyle] = useState("glass"); // "glass" (por defecto Glass)
  const [switching, setSwitching] = useState(false);
  const [page, setPage] = useState(0);
  const { cols, rows, size: pageSize } = useGridConfig(cardStyle);

  //=====================================FUNCTIONS INPUT MENU POSITIONS==========================================================
  const handlerChangeInputMenu = (txt) => {

    oledComunication(0, '2,0')
    /*setTimeout(() => {
      oledComunication(0, '2,1,4,40,20,' + txt)
    }, 50);
*/
    if (txt === '00') {
      localStorage.setItem("GroupsByMachine", '');

      setTimeout(() => {
        oledComunication(0, '2,0')
      }, 100);

      setTimeout(() => {
        oledComunication(0, '2,1,1,35,30,Preparando')
      }, 150);

      setTimeout(() => {
        oledComunication(0, '2,1,1,40,40,Máquina...')
      }, 200);


      setTimeout(() => {
        window.location.reload(true);
      }, 250);

    } else if (txt.length < 3) {
      setTimeout(() => { if (txt.length == 2) { selectedProduct(txt) } }, 400)

    } else {
      clearInputMenu(txt[2])
      setTimeout(() => { if (txt.length == 2) { selectedProduct(txt) } }, 400)

    }


    function selectedProduct(txt) {
      oledComunication(0, '2,0')
      let newList = groups.filter(({ group_id, amount }) => group_id != null && amount > 0)
      console.log(newList);
      let selectPosition = newList.find(({ positionX, positionY }) => positionX === parseInt(txt[0]) && positionY === parseInt(txt[1]))

      if (selectPosition != undefined) {
        clearStatussentorandlimitDigit(1, "2,1,4,40,20,")
        console.log("Encontre algo");
        console.log(selectPosition);
        getGroupById(selectPosition.group_id, selectPosition.positionX, selectPosition.positionY, selectPosition.amount, selectPosition.position_id, 0, selectPosition.detail_group)
        setHandlerAutoAdd(true)

        //show in oled screen
        setTimeout(() => {
          oledComunication(0, '2,1,1,0,10,' + txt + ":" + selectPosition.name)
        }, 50);
        setTimeout(() => {
          oledComunication(0, '2,1,3,20,30,$' + parseFloat(selectPosition.price).toFixed(2))
        }, 100);

        setTimeout(() => {
          oledScreenPayments()
        }, 1000);
      } else {
        clearStatussentorandlimitDigit(2, "2,1,4,40,20,")
        oledComunication(0, '2,1,1,25,20,Este producto')
        setTimeout(() => {
          oledComunication(0, '2,1,1,35,30,no existe.')
          setTimeout(() => {
            //RESET OLEDSCREEN
            initOledScreen();
          }, 1000);
        }, 50);
      }

      clearInputMenu()
    }
  }

  const clearInputMenu = (txt) => {
    if (txt == undefined) { inputRefMenu.current.value = "" } else { inputRefMenu.current.value = txt }
    inputRefMenu.current.focus()
    console.log('Limpiar');
  }

  const handlerActionLayoutMenu = () => {
    if (machine.machine_subtype_code == "VCG" || machine.machine_subtype_code == "VPD") {

    } else {
      inputRefMenu.current.focus()
    }
  }
  //===============================================================================================


  // get status change of the info to  menu
  const getStatusContentMenu = async () => {
    let dataGroupsLocal = localStorage.getItem("GroupsByMachine");
    let dataCategoriesLocal = localStorage.getItem("Categories");
    if (dataGroupsLocal == undefined || dataGroupsLocal == null || dataGroupsLocal == "" || dataGroupsLocal == []) {
      getGroupsByMachine();
      getCategories();
    } else {
      dataGroupsLocal = JSON.parse(localStorage.getItem("GroupsByMachine"))
      dataCategoriesLocal = JSON.parse(localStorage.getItem("Categories")) !== undefined && JSON.parse(localStorage.getItem("Categories")) !== null ? JSON.parse(localStorage.getItem("Categories")) : []
      try {
        const response = await StatusMenu.getContentMenu(token, machine.id)
        console.log(response.data.data.content_status);

        if (response.data.data.content_status == false) {
          setGroups(dataGroupsLocal);

          if (dataCategoriesLocal.length > 0) {
            setCategories(dataCategoriesLocal)
          } else {
            getCategories();
          }
          console.log("Entre GroupsByMachine");
        } else {
          console.log("Entre GroupsByMachinen else");
          getGroupsByMachine();
          getCategories();
        }

      } catch (err) {
        console.log("Entre GroupsByMachinen error");
        console.log(err);
      }
    }
  }


  //Function get the groups by machine
  const getGroupsByMachine = async () => {
    try {
      const response = await GroupsFechtAPI.getGroupsByMachine(machine.id, token);
      //console.log(response);
      const response1 = await GroupsFechtAPI.getGroupsByBranchoffice(branchoffice.id, token)

      let groups = response.data.groups


      const groupIndex = response1.data.data.reduce((acc, element) => {
        if (Array.isArray(acc[element.group_id]) && acc[element.group_id].length > 0) {
          acc[element.group_id].push(element);
        } else {
          acc[element.group_id] = [element]
        }
        return acc
      }, {})
      //We add to the groups the info detail 
      groups = groups.map(element => {
        return {
          ...element,
          detail_group: groupIndex[element.group_id] === undefined ? [] : groupIndex[element.group_id]
        }
      });

      localStorage.setItem("GroupsByMachine", JSON.stringify(groups))
      setGroups(groups)
      setMenuFilteredByCategory(false)
    } catch (err) {
      setGroups([])
      setMenuFilteredByCategory(false)
    }
  }


  //Function get the groups by machine
  const getGroupsByMachineByCategory = async (category_id) => {
    try {
      console.log("category_id", category_id);
      const response = await GroupsFechtAPI.getGroupByCategoryAndPosition(machine.id, category_id, token);
      console.log(response);
      setGroups(response.data.groups)
      setMenuFilteredByCategory(true)
    } catch (err) {
      setGroups([])
      setMenuFilteredByCategory(false)
    }
  }

  //Function get group by id
  const getGroupById = async (group_id, X, Y, stock, position_id, index, detail_group) => {
    getRunningstate()
    setAtivityTimer(7)
    setStatusTempTurnNow(false)
    console.log("index del producto: " + index);
    setShowModalProduct(true);

    if (detail_group != undefined) {
      let group = ''

      if (Array.isArray(detail_group)) {
        group = detail_group[0]
      } else {
        group = detail_group
      }
      group.preparation = group.group_preparation
      //set price with dicount
      let discount_item = 0;
      group.unit_discount = discount_item;
      group.product_discount = discount_item;
      group.descuento = discount_item;
      group.discount = discount_item;

      setSelectGroup({ ...group, X: X, Y: Y, stock: stock, position_id: position_id, index: index })
    } else {
      LoadingAlert()
      try {
        const response = await GroupsFechtAPI.getGroupById(group_id, token, branchoffice.id)
        let group_item = response.data.data

        //set price with dicount
        let discount_item = 0;

        group_item.unit_discount = discount_item;
        group_item.product_discount = discount_item;
        group_item.descuento = discount_item;
        group_item.discount = discount_item;
        //--------------------------------------------------
        setSelectGroup({ ...group_item, X: X, Y: Y, stock: stock, position_id: position_id, index: index })
        AlertSmall("Consulta exitosa")

        groups.forEach((group) => {
          if (group.group_id == group_id) {
            group.detail_group = { ...group_item, X: X, Y: Y, stock: stock, position_id: position_id, index: index }
          }
        });


        setGroups(groups)
        localStorage.setItem("GroupsByMachine", JSON.stringify(groups))
      } catch (err) {
        console.log(err);
      }
    }
  }

  const maintenanceEnter = async () => {
    try {
      const response = await VendingAndroidFetchAPI.maintenanceEnter()
      localStorage.setItem("machine_maintenance", 1)
      ErrorAlert("La máquina ha entrado en modo mantenimiento,", response.data.message, "success")
    } catch (err) {
      ErrorAlert("No se pudo entrar en modo mantenimiento,", " por favor intente de nuevo.", "error")
      console.log(err);
    }
  }

  const maintenanceExit = async () => {
    try {
      const response = await VendingAndroidFetchAPI.maintenanceExit()
      localStorage.setItem("machine_maintenance", 0)
      ErrorAlert("La máquina ha salido del modo mantenimiento,", response.data.message, "success")
    } catch (err) {
      ErrorAlert("No se pudo salir del modo mantenimiento,", " por favor intente de nuevo.", "error")
      console.log(err);
    }
  }

  const getMachineById = async () => {

    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token)
      console.log("response_machine", response_machine.data.data.machine_maintenance);
      console.log("Machine maintenance state changed: ", response_machine.data.data.machine_maintenance, "old state: ", parseInt(localStorage.getItem("machine_maintenance")));

      if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
        if (parseInt(localStorage.getItem("machine_maintenance")) !== response_machine.data.data.machine_maintenance) {
          if (response_machine.data.data.machine_maintenance == 1) {
            maintenanceEnter()
          } else {
            maintenanceExit()
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  const getRunningstate = async () => {
    if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {
      try {
        const response = await VendingAndroidFetchAPI.getRunningState(ipAndroid)
        console.log(response.data.runningState);
        console.log("runningState", response.data.runningState);

        if (response.data.runningState == 2) {
          setStatusComunicationVending(true)
        } else {
          setStatusComunicationVending(false)
        }
      } catch (err) {
        setStatusComunicationVending(false)
      }
    }
  }

  const getTempAndorid = async () => {
    try {
      let data = {
        "funcion": "GETTEMP",
        "boxid": 1
      }
      const response = await VendingAndroidFetchAPI.generalFunctionVending(ipAndroid, data)
      console.log("datos de la temperatura", response.data.data);
      let data_Response = response.data.data
      console.log(data_Response);
      //console.log(response);
      setTemperature(data_Response[0])
      setHumidity(data_Response[3])
      //setStatusComunicationVending(true)
      if (parseInt(data_Response[3]) == 0 || parseInt(data_Response[0]) < 0) {
        setStatusComunicationVending(false)
        return false
      } else {
        setStatusComunicationVending(true)
        return true
      }
    } catch (err) {
      setStatusComunicationVending(false);
      console.log(err);
      return false
    }

  }


  //get temperature of the vending machine
  const getTemp = async (force = false) => {
    if (machine.machine_subtype_code === "VCG" || machine.machine_subtype_code === "VPD") {
      //let data = { funcion: "GETTEMP", datos: [{ X: "0", Y: "0" }] }
      let data = { "nboxid": 1 }
       try {
        const responseGetTemp = await RequestLocalFetchAPI.currenttemp(data)
        let data_Response = responseGetTemp.data.Result
        console.log(data_Response);
        //console.log(response);
        setTemperature(data_Response[0])
        setHumidity(data_Response[2])

        console.log("Temperatura", data_Response[0]);
        console.log("Humedad", data_Response[2]);
        //setStatusComunicationVending(true)
        if (parseInt(data_Response[2]) == 0 || parseInt(data_Response[0]) < 0) {
          setStatusComunicationVending(false)

          try {
            let dataInit = { "nboxid": 1, "x": "vendingKey", "y": "vendingCOM" }
            const reponseInitSerial = RequestLocalFetchAPI.initSerialComunication(dataInit)
          } catch (err) {
            console.log(err);
          }

          return false
        } else {
          setStatusComunicationVending(true)
          return true
        }
      } catch (err) {
        setStatusComunicationVending(false);
        console.log(err);
        return false
      } 
    } else if (machine.machine_subtype_code === "VAG" || machine.machine_subtype_code === "VAP") {

      return await getTempAndorid()
    } else {
      //setStatusComunicationVending(true)
      if (force == true || statusTempTurnNow == false) {

        console.log(statusTempTurnNow)
        try {
          let data = [{ "comandaVendType": 0, "vendingCode": "4,1" }]
          const response = await VendingSnakkyFetchAPI.keypad(data)
          console.log(response)

          setStatusComunicationVending(true)
        } catch (err) {
          setStatusComunicationVending(false)
          return false
        }

        return await new Promise((resolve) => {
          setTimeout(async () => {
            console.log(statusTempTurnNow)
            try {
              let data = [{ "comandaVendType": 0, "vendingCode": "4,1" }]
              const response = await VendingSnakkyFetchAPI.getTemp(data)
              console.log(response)

              let dataInformation = response.data.Informacion.split(',')

              setTemperature(dataInformation[1])
              setHumidity(dataInformation[0])
              console.log(response.data.Informacion)

              setStatusComunicationVending(true)
              resolve(true)
            } catch (err) {
              setStatusComunicationVending(false)
              resolve(false)
            }
          }, 500);
        });
      }
    }

    return statusComunicationVending

  }

  const getBusinessConfig = async () => {
    try {
      const response = await BusinessFetchAPI.getBusinessByidConfig(business.id, token);
      console.log(response.data.data.logo);
      setLogo(response.data.data.logo)
      getOrderNumber()

      if (machine.machine_subtype_code == "VGG") {
        localStorage.setItem('positions', JSON.stringify([12, 12, 12, 12, 12, 12, 12, 12]))
      }


    } catch (err) {
      console.log(err);
    }
  }

  //Function get categories
  const getCategories = async () => {
    try {
      //const response = await CategriesPosFetchAPI.getCategoriesByBranchOffices(branchoffice.id, 1, token);
      const response = await MachinesFetchAPI.getMachineCategories(machine.id, token);
      localStorage.setItem("Categories", JSON.stringify(response.data.categories))
      console.log(response.data.categories);
      setCategories(response.data.categories)
      //setCategories(response.data.data)

    } catch (err) {
      setCategories([])
      console.log(err);
    }
  }

  // add product to shopingcart
  const addProduct = () => {
    getTemp();

    // Para probar sin hardware local (vending física) cambia esta constante a `true`
    const bypassVendingStatusCheck = false;
    if (!bypassVendingStatusCheck && statusComunicationVending == false) {// esto debe estar en false, para pruebas de desarrollo true
      setShowModalProduct(false)
      setShowModaloutService(true)
      setAtivityTimer(0)
    } else {
      setShowModalProduct(false)
      setShowModalShopingCart(false);
      setShowModalPayment(true)
      setStatusScreen(true);
      //We put the amount in the product
      selectGroup.amount = amount;
      selectGroup.cantidadItem = amount;
      selectGroup.delivery_type = "para llevar";
      selectGroup.discount = 0;
      //We set the product in the shopping cart
      let stateaddProduct = true;
      //We check if the product is in the shopping cart
      shoppingCart.forEach(group => {
        if (group.group_id == selectGroup.group_id) {
          group.amount = (group.amount + amount);
          group.cantidadItem = (group.cantidadItem + amount);
          stateaddProduct = false;
        }
      });

      //condition to add product or increment
      if (stateaddProduct == true) {
        setShoppingCart([...shoppingCart, selectGroup]);
      } else {
        // OJO: antes esto era setShoppingCart(shoppingCart) - la MISMA referencia del array.
        // React compara por referencia (Object.is) para decidir si dispara re-render/efectos, asi
        // que ese setState era un no-op para React: el useEffect([shoppingCart]) de
        // VendingModalCart que recalcula los totales (calculateInvoiceTotals) nunca se volvia a
        // ejecutar al re-seleccionar el MISMO producto, dejando Total/itbms/taxes/subtotal
        // congelados en lo que fueran antes (ej. 0 si el carrito se habia vaciado). El spread crea
        // una referencia nueva para que React si detecte el cambio.
        setShoppingCart([...shoppingCart]);
      }

      //initialize state
      setAmount(1);
      //Event handler
      setEventHandler(1);
    }

  }

  // get order number in process
  const getOrderNumber = async () => {
    //let branchoffice_vending =  JSON.parse(localStorage.getItem("branchoffice_vending"));
    try {
      const response = await OrderNumberFetchAPI.getOrderNumber(branchoffice.id, token)
      console.log("Order number: ", response);
      setOrderNumber(response.data.next_transaction_code);
    } catch (err) {
      console.log(err);
    }
  }

  //get time update
  let intervalTime = 0
  const getTime = () => {
    if (publicity.length > 0) {
      if (activity > 3) {
        if (activity == 4) {

          //----------------------------
          setShowModalPayment(false);
          setShowModalProduct(false);
          setShowModalAuthOperator(false);
        }
      }
    }
    console.log(activity)

    //calculate time 
    let date = new Date();
    date = date.toString().slice(15, 21)
    let datasegmentTime = date.split(":")

    let hour = parseInt(datasegmentTime[0])
    let statusTime = ""
    if (hour > 12) {
      hour = (hour - 12)
      statusTime = "PM"
    } else {
      statusTime = "AM"
    }

    let time = hour + ":" + datasegmentTime[1] + " " + statusTime
    setTime(time);

    //setEventHandlerTime(1)
  }

  //================================OLED=======================================================
  const initOledScreen = () => {

    oledComunication(0, '5,0,15,0') //color led exterior vending
    oledComunication(0, '2,0')
    setTimeout(() => {
      oledComunication(0, '2,1,1,25,20,Seleccione un')
    }, 50);

    setTimeout(() => {
      oledComunication(0, '2,1,1,35,30,producto.')
    }, 100);

    setTimeout(() => {
      getTemp()
    }, 2000);
  }

  const oledScreenPayments = () => {

    oledComunication(0, '5,0,9,0') //color led exterior vending
    oledComunication(0, '2,0')
    setTimeout(() => {
      oledComunication(0, '2,1,1,20,0,Como desea pagar ')
    }, 50);




    let array1 = []
    let array2 = []

    payments.forEach((payment, index) => {
      if ((index + 1) <= 4) {
        array1.push(payment)
      } else {
        array2.push(payment)
      }
    })

    array1.forEach((payment, index) => {

      let name = ''
      if (payment.payment == 'MasterCard') {
        name = 'MCard'
      } else {
        name = payment.payment
      }
      setTimeout(() => {
        oledComunication(0, '2,1,1,0,' + ((index + 1) * 10) + ',' + (index + 1) + '.' + name + ' ')
      }, (100 + ((index + 2) * 10)));
    })

    array2.forEach((payment, index) => {

      let name = ''
      if (payment.payment == 'MasterCard') {
        name = 'MCard'
      } else {
        name = payment.payment
      }
      //setTimeout(() => {
      oledComunication(0, '2,1,1,48,' + ((index + 1) * 10) + ',' + (index + 5) + '.' + name)
      //}, (100 + ((index + 2) * 10)));
    })

    setTimeout(() => {
      oledComunication(0, '2,1,0.5,30,55,0.CANCELAR')
    }, 500);
  }

  const clearStatussentorandlimitDigit = async (data, settingtxt) => {
    try {

      await VendingSnakkyFetchAPI.clearData({ "limit": data, "setting": settingtxt })

    } catch (err) {
      console.log(err);
    }
  }

  const refresh = () => {
    window.location.reload(true);
  }

  //===========================================================================================


  //Hook to load the initial info
  useEffect(() => {
    (async () => {
      getPublicity();
      getBusinessConfig();
      getTime();
      setStatusTempTurnNow(true)
      setNameBusiness(business.name)
      getMachineById()

      inputRefMenu.current.focus()
      getStatusContentMenu();
      if (machine.machine_subtype_code == "VGG") {
        clearStatussentorandlimitDigit(2, "2,1,4,40,20,")
        initOledScreen()
      } else {
        getTemp()
      }
    })()

    setEventHandlerMenu(0)
  }, [eventHandlerMenu]);



  //timer activity and time
  useEffect(() => {


    const interval = setInterval(() => {
      activity = (activity + 1)
      getTime();
      getTemp();
      //console.log("Secuencia " + activity);
    }, 60000); // Ejecutar cada 1000 ms (1 segundo)
    return () => {
      clearInterval(interval); // Limpiar el intervalo al desmontar el componente
    };
  }, [statusTempTurnNow]);

  //Timer of filtered menu by category
  useEffect(() => {
    //If the menu is filtered by category, we set an interval to refresh the menu to all the products in the machine
    if (menuFilteredByCategory == true) {
      const interval = setInterval(() => {
        getGroupsByMachine();
      }, 60000); // Ejecutar en  60000 ms (1 minuto)
      return () => {
        clearInterval(interval); // Limpiar el intervalo al desmontar el componente
      };
    }
  }, [menuFilteredByCategory]);

  //click  in the screen
  useEffect(() => {
    const handleClick = (event) => {
      if (activity > 1000) {
      } else {
        activity = 0;
      }
    };

    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    };

  }, []); // Se ejecuta una vez al montar el componente

  //add item auto
  useEffect(() => {
    if (handlerAutoAdd == true) {
      addProduct()
    }
  }, [handlerAutoAdd]);

  useEffect(() => {
    // Establecer un intervalo
    const intervalId = setInterval(() => {
      // Validar el valor actualizado del contador con una instrucción if

      console.log("ahora estoy en "
        + activityTimer + " y la prioridad es " + priority
      );
      if (priority == 0) {
        switch (activityTimer) {
          case 0:
            refresh()
            break;
          case 1:
            // activity 1 determines that there is navigation activity
            setAtivityTimer(0);
            break;
          case 2:
            break;
          case 3:
            if (publicity.length > 0) { setShowModalIdel(true) }
            break;
          case 5:
            setAtivityTimer(6);
            break;
          case 6:
            setAtivityTimer(7);
            break;
          case 7:
            setAtivityTimer(1);
            break;
        }

      } else {
        //priority event
        //console.log(" hay prioridad");
        if (activityTimer == 3) {//actividad 3 determina que a finalizado la transaccion
          setAtivityTimer(4);
        } else if (activityTimer == 4) {//activity 4 redirects to the first step and restarts the transaction
          setAtivityTimer(0);

        }
      }
    }, 30000);

    // Limpiar el intervalo al desmontar el componente
    return () => clearInterval(intervalId);
  }, [activityTimer, priority]);





  // ---------- NUEVO: lista de productos filtrada (misma lógica que antes) ----------
  const productsFiltered = useMemo(() => {
    let positions = null;
    try { positions = JSON.parse(localStorage.getItem('positions')); } catch (e) { positions = null; }
    let array = [];

    if (positions != undefined && Array.isArray(positions) && positions.length > 0) {
      array = groups.filter(producto => producto.name !== null && producto.amount > 0 && producto.positionX < (positions.length + 1));
    } else {
      console.log("No hay posiciones / parametro de posiciones");
    }

    const productNoNulls = [];
    array.forEach(p => {
      if (productNoNulls.findIndex(item => item.group_id === p.group_id) === -1) {
        productNoNulls.push(p);
      }
    });

    // Ordenar asc por positionX (misma lógica que ordenarAsc original pero sin mutar)
    const sorted = [...productNoNulls].sort((a, b) => {
      if (a.positionX === b.positionX) return a.positionY - b.positionY;
      return a.positionX - b.positionX;
    });
    return sorted;
  }, [groups]);

  // ---------- NUEVO: paginación ----------
  const pages = useMemo(() => {
    const out = [];
    for (let i = 0; i < productsFiltered.length; i += pageSize) {
      out.push(productsFiltered.slice(i, i + pageSize));
    }
    return out.length ? out : [[]];
  }, [productsFiltered, pageSize]);
  const totalPages = pages.length;

  useEffect(() => {
    if (page >= totalPages) setPage(Math.max(0, totalPages - 1));
  }, [totalPages, page]);

  const goPrevPage = useCallback(() => setPage((p) => Math.max(0, p - 1)), []);
  const goNextPage = useCallback(() => setPage((p) => Math.min(totalPages - 1, p + 1)), [totalPages]);

  // ---------- NUEVO: cambio de estilo con fade ----------
  const changeStyle = useCallback((next) => {
    if (next === cardStyle) return;
    setSwitching(true);
    setTimeout(() => {
      setCardStyle(next);
      requestAnimationFrame(() => requestAnimationFrame(() => setSwitching(false)));
    }, 240);
  }, [cardStyle]);

  // ---------- NUEVO: función handler del click en card — llama al getGroupById original ----------
  const handleCardClick = (product, globalIdx) => {
    getGroupById(
      product.group_id,
      product.positionX,
      product.positionY,
      product.amount,
      product.position_id,
      globalIdx,
      product.detail_group
    );
  };

  const getPublicity = async () => {

    try {
      const response = await PublicityFechtAPI.getPublicity(machine.id, token);

      setPublicity(response.data.publicity)
      setVideo(response.data.publicity)
      setVideoNow(response.data.publicity[0].video_url)
      activity = 0
      //console.log(response.data.publicity)

    } catch (err) {
      setPublicity([])
      activity = 1000
      console.log(err)
    }
  }

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleContextMenu = (e) => {
    e.preventDefault(); // Evita que aparezca el menú contextual
  };

  const handleMouseDown = (e) => {
    if (e.button === 2) {
      e.preventDefault(); // Evita que el clic derecho dispare el menú contextual
    }
  };

  const handlerSuppor = async () => {
    setAtivityTimer(7)
    try {
      const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, token)
      console.log(response_machine);
      setContentSupport({ title: "Solicitud de ayuda", body: [{ "text": "Máquina vending: " + response_machine.data.data.machine_name + "solicitan ayuda." }, { text: "1" }] })
      setShowModalSupport(true)
    } catch (err) {
      console.log(err);
    }

  }

  function ordenarAsc(p_array_json, p_key) {
    let newArray = p_array_json.sort(function (a, b) {
      return a[p_key] > b[p_key];
    });


    return (newArray.reverse())
  }

  // -------- Estilo inline para grid CSS variables --------
  const gridStyle = { "--grid-cols": cols, "--grid-rows": rows };

  return (
    < >
      <main
        className="vmm-root"
        data-style={cardStyle}
        data-switching={switching || undefined}
        onContextMenu={(e) => handleContextMenu(e)}
        onMouseDown={(e) => handleMouseDown(e)}
        onClick={() => (handlerActionLayoutMenu(), inputRefMenu.current.focus())}
      >
        {/* ========== HEADER FIJO ========== */}
        <header className="vmm-header">
          <button
            className="vmm-iconbtn"
            data-bs-toggle="modal"
            data-bs-target="#CategoriesModal"
            aria-label="Buscar / Categorías"
          >
            <i className="uil uil-search-alt"></i>
          </button>

          <div className="vmm-brand">
            <VendingModalOperator
              logo={logo}
              showModalAuthOperator={showModalAuthOperator}
              setShowModalAuthOperator={setShowModalAuthOperator}
              humidity={humidity}
              temperature={temperature}
              setShowModalStock={setShowModalStock}
              showModalStock={showModalStock}
              setEventHandlerMenu={setEventHandlerMenu}
              showModalKeyCode={showModalKeyCode}
              setShowModalKeyCode={setShowModalKeyCode}
              setStatusScreen={setStatusScreen}
              nameBusiness={nameBusiness}
              setAtivityTimer={setAtivityTimer}
            ></VendingModalOperator>
            {/* <div className="vmm-brand-title">{nameBusiness || "Don Lee"}</div> */}
          </div>

          <button
            className="vmm-iconbtn"
            onClick={async () => { handlerSuppor() }}
            aria-label="Información"
          >
            <i className="uil uil-info-circle"></i>
          </button>

          {/* Operador invisible (se dispara con key code). Lo mantenemos intacto */}
          <div style={{ position: "absolute", width: 0, height: 0, overflow: "hidden" }}>
            <VendingModalOperator
              logo={logo}
              showModalAuthOperator={showModalAuthOperator}
              setShowModalAuthOperator={setShowModalAuthOperator}
              humidity={humidity}
              temperature={temperature}
              setShowModalStock={setShowModalStock}
              showModalStock={showModalStock}
              setEventHandlerMenu={setEventHandlerMenu}
              showModalKeyCode={showModalKeyCode}
              setShowModalKeyCode={setShowModalKeyCode}
              setStatusScreen={setStatusScreen}
              nameBusiness={nameBusiness}
              setAtivityTimer={setAtivityTimer}
            />
          </div>
        </header>

        {/* ========== MIDDLE (grid paginado) — sin flechas a los lados ========== */}
        <section className="vmm-middle">
          <div className="vmm-stage">
            <div className="vmm-viewport">
              <div
                className="vmm-pages"
                style={{ transform: `translateX(-${page * 100}%)` }}
              >
                {pages.map((pageItems, pIdx) => (
                  <div
                    key={pIdx}
                    className={`vmm-page ${pIdx === page ? "is-active" : ""}`}
                    aria-hidden={pIdx !== page}
                  >
                    <div className="vmm-grid" style={gridStyle}>
                      {pageItems.map((product, itemIdx) => {
                        const globalIdx = pIdx * pageSize + itemIdx;
                        return (
                          <article
                            key={product.group_id || `${product.positionX}-${product.positionY}`}
                            className="vmm-card"
                            onClick={(e) => { e.stopPropagation(); handleCardClick(product, globalIdx); }}
                          >
                            <div className="vmm-card-media">
                              <img src={buildCloudinaryImageUrl({ url: product.img, width: 300, type: "image", quality: "auto" })} alt={product.name} loading="lazy" />
                              <span className="vmm-card-slot">{product.positionX}-{product.positionY}</span>
                              <span className="vmm-card-dot" />
                            </div>
                            <div className="vmm-card-body">
                              <div className="vmm-card-name" title={product.name}>{product.name}</div>
                              <div className="vmm-card-price">
                                <small>$</small>{Number(product.price).toFixed(2)}
                              </div>
                            </div>
                          </article>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ========== FOOTER FLOTANTE: flechas + status pill ========== */}
        <footer className="vmm-floatbar">
          <button
            className="vmm-float-nav"
            onClick={(e) => { e.stopPropagation(); goPrevPage(); }}
            disabled={page === 0}
            aria-label="Página anterior"
          >
            <i className="uil uil-angle-left-b"></i>
          </button>

          <div className="vmm-statusbar">
            <div className="vmm-status-item">
              <i className="uil uil-temperature"></i>
              <span><b>{temperature}°</b> C</span>
            </div>
            <div className="vmm-status-divider" />
            <div className="vmm-status-item">
              <i className="uil uil-thermometer"></i>
              <span><b>{humidity}%</b></span>
            </div>
            <div className="vmm-status-divider" />
            <div className="vmm-status-item">
              <i className="uil uil-clock"></i>
              <span><b>{time}</b></span>
            </div>
            <div className="vmm-status-divider" />
            <div className="vmm-status-item vmm-status-page">
              <b>{page + 1}</b><span style={{ opacity: .5 }}>/{totalPages}</span>
            </div>
          </div>

          <button
            className="vmm-float-nav"
            onClick={(e) => { e.stopPropagation(); goNextPage(); }}
            disabled={page >= totalPages - 1}
            aria-label="Página siguiente"
          >
            <i className="uil uil-angle-right-b"></i>
          </button>
        </footer>
      </main>

      {/** App modals (todos intactos) */}
      <VendingModalCategories categories={categories} setGroups={setGroups} getGroupsByMachineByCategory={getGroupsByMachineByCategory} getGroupsByMachine={getGroupsByMachine}></VendingModalCategories>
      {/*<VendingModalCart setShoppingCart={setShoppingCart} shoppingCart={shoppingCart} showModalShopingCart={showModalShopingCart} setShowModalShopingCart={setShowModalShopingCart} eventHandler={eventHandlerProduct} dataClient={dataClient} setDataClient={setDataClient} showModalPayment={showModalPayment} setShowModalPayment={setShowModalPayment} setEventHandlerMenu={setEventHandlerMenu}></VendingModalCart>*/}

      <VendingModalProduct selectGroup={selectGroup} setShoppingCart={setShoppingCart} shoppingCart={shoppingCart}
        showModalProduct={showModalProduct} setShowModalProduct={setShowModalProduct} setShowModalShopingCart={setShowModalShopingCart}
        setEventHandlerMenu={setEventHandlerMenu} showModalShopingCart={showModalShopingCart} dataClient={dataClient} setDataClient={setDataClient}
        groups={groups} setSelectGroup={setSelectGroup} getGroupById={getGroupById} showModalPayment={showModalPayment} setShowModalPayment={setShowModalPayment}
        setStatusScreen={setStatusScreen} statusScreen={statusScreen} getTemp={getTemp} statusComunicationVending={statusComunicationVending} amount={amount}
        setAmount={setAmount} showModaloutService={showModaloutService} setShowModaloutService={setShowModaloutService} orderNumber={orderNumber}
        setOrderNumber={setOrderNumber} addProduct={addProduct} getOrderNumber={getOrderNumber} payments={payments} setPayments={setPayments}
        oledScreenPayments={oledScreenPayments}
        setStatusTempTurnNow={setStatusTempTurnNow} setAtivityTimer={setAtivityTimer}>


      </VendingModalProduct>
      <VendingStock humidity={humidity} temperature={temperature} setShowModalStock={setShowModalStock} showModalStock={showModalStock} setEventHandlerMenu={setEventHandlerMenu} eventHandlerMenu={eventHandlerMenu} setStatusScreen={setStatusScreen} setAtivityTimer={setAtivityTimer}></VendingStock>
      <VendingModalSupport showModalSupport={showModalSupport} setShowModalSupport={setShowModalSupport} contentSupport={contentSupport} setEventHandlerMenu={setEventHandlerMenu} setAtivityTimer={setAtivityTimer}></VendingModalSupport>




      <VendingIdel showModalIdel={showModalIdel} setShowModalIdel={setShowModalIdel} publicity={publicity} video={video} inputRefMenu={inputRefMenu} videoNow={videoNow} setVideoNow={setVideoNow} ></VendingIdel>

      <TimerScreen></TimerScreen>


      {/*Input navegation */}

      <div className='position-absolute '>
        <input id="inputlistenerMenu" ref={inputRefMenu} type='text' inputMode="none" onChange={(e) => handlerChangeInputMenu(e.target.value)} className='vending-input-qr' autoFocus></input>
      </div>


    </>
  )
}

export default VendingMenu
